<template>
<div class="topologymap-category-window">
  <div class="popup-panel">
    <div class="popup-header">
      <div>
        <el-menu class="el-menu" :default-active="currentActive" mode="horizontal" @select="changeMenu">
          <el-menu-item index="1">범례</el-menu-item>
          <el-menu-item index="2">이벤트</el-menu-item>
          <el-menu-item index="3">{{ thirdMenuTitle }}</el-menu-item>
        </el-menu>
      </div>
      <el-button class="close-btn" size="small" type="no-border" @click="closeBtnClick"><i class="far fa-times"></i></el-button>
    </div>
    <div class="popup-contents">
      <div v-show="currentActive === '1'" class="category">
        <div class="category-line">
          <div class="title">회선</div>
          <div class="contents map-help-column-bg">
            <div>
              <div class="image map-help-legend-line1"></div>
              <div class="text">&lt;100MBPS</div>
            </div>
            <div>
              <div class="image map-help-legend-line2"></div>
              <div class="text">&lt;1GBPS</div>
            </div>
            <div>
              <div class="image map-help-legend-line3"></div>
              <div class="text">&gt;=1GBPS</div>
            </div>
          </div>
        </div>
        <div class="category-managedobject">
          <div class="title">관리대상</div>
          <div class="contents map-help-column-bg">
            <div>
              <div class="image map-help-legend-active"></div>
              <div class="text">active</div>
            </div>
            <div>
              <div class="image map-help-legend-standby"></div>
              <div class="text">standby</div>
            </div>
            <div>
              <!-- <div class="image map-help-legend-event">
                <span class="event-count">2</span>
              </div>
              <div class="text">이벤트 개수</div> -->
            </div>
          </div>
        </div>
      </div>
      <div v-show="currentActive === '2'" class="event">
        <div class="title">이벤트</div>
        <div class="contents map-help-column-bg">
          <div v-for="(event, index) in eventlevels" :key="index" class="event-wrapper">
            <div class="color-area" :style="`background: ${event.eventlevelColorBg};`"></div>
            <div class="label-area">{{ event.eventlevelName }}</div>
          </div>
        </div>
      </div>
      <div v-show="currentActive === '3'">
        <w-category-dynamic-menu ref="categoryDynamicMenu" :thirdMenuTitle.sync="thirdMenuTitle"></w-category-dynamic-menu>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { isEmpty } from '@/utils/basic';
import { MapPopup } from '@/views/topologymap/js/maps';
import MapConst from '@/constants/topologymap';
import WCategoryDynamicMenu from '@/views/topologymap/components/monitoring/CategoryDynamicMenu';

export default {
  name: 'WCategoryWindow',
  components: {
    WCategoryDynamicMenu,
  },
  data() {
    return {
      config: {
        type: MapConst.POPUP_TYPE.WINDOW,
        x: window.innerWidth - 460,
        y: 110,
        width: 400,
        height: 191,
        minWidth: 400,
        minHeight: 191,
        clickToClose: false,
        scrollable: false,
        resizable: false,
        draggable: false,
      },
      currentActive: '1',
      thirdMenuTitle: MapConst.HELP.MENU_TITLE_AT_MONITORING,
    };
  },
  computed: {
    eventlevels() {
      const eventlevelList = this.$store.getters.eventlevelList;
      if (isEmpty(eventlevelList)) {
        return [];
      }
      return eventlevelList.filter((eventlevel) => eventlevel.eventlevelId !== 'test');
    },
  },
  methods: {
    /**
     * 헤더에 닫기 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    closeBtnClick() {
      MapPopup.closeAndHide(this.$options.name, true);
    },
    changeMenu(index) {
      this.$refs.categoryDynamicMenu.onClickMoreButton(false);
      this.currentActive = index;
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/_variable.scss';
.topologymap-category-window {
  $header-height: 35px;

  @mixin item-title {
    .title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 25px;
      font-family: 'Malgun Gothic';
      font-size: 12px;
      color: $evilgray;
      margin-bottom: 5px;
      padding-left: 14px;
    }
  }
  @mixin item-content {
    .contents {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 14px;
      &> div {
        display: flex;
        flex: 1;
      }
      .image {
        display: flex;
        justify-content: center;
        align-items: center;
        .event-count {
          font-family: 'Lato';
          font-size: 12px;
          color: white;
        }
      }
      .text {
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Malgun Gothic';
        font-size: 11px;
        color: $luckygray;
      }
    }
  }

  height: 100%;
  .popup-panel {
    height: 100%;
    padding: 0px 15px 5px 15px;
    border-top: 3px solid #5b739f;
  }

  .popup-header {
    height: $header-height;
    color: #505f9d;
    font-size: 15px;
    position: absolute;
    width: calc(100% - 30px);
    .el-menu.el-menu--horizontal>.el-menu-item {
      height: 35px;
      line-height: 35px;
    }
    .el-menu--horizontal>.el-menu-item.is-active {
      font-weight: bold;
      border-bottom: 3px solid #505f9d;
    }
    .close-btn {
      position: absolute;
      right: 0px;
      top: 5px;
    }
  }

  .popup-title-wrapper {
    font-weight: bold;
    position: absolute !important;
  }

  .popup-contents {
    height: calc(100% - #{$header-height});
    margin-top: $header-height;
    overflow-y: hidden;
    padding: 0px 1px;
    .category {
      height: 100%;
      @include item-title;
      @include item-content;
      .category-line, .category-managedobject {
        height: 63px;
        margin-bottom: 10px;
      }
    }
    .event {
      height: calc(100% - #{$header-height});
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @include item-title;
      .contents {
        padding: 5px 14px;
        display: flex;
        .event-wrapper {
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: center;
          align-items: center;
        }
        .color-area {
          width: 100%;
          height: 40%;
        }
        .label-area {
          display: flex;
          justify-content: center;
          font-family: 'Malgun Gothic';
          font-size: 11px;
          color: $luckygray;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/CategoryWindow.vue